import { DatePicker, Select } from "antd";
import { motion } from "framer-motion";
import styled from "styled-components";

const FLIGHT_RESULT_LARGE_WIDTH = "520px";
const FLIGHT_RESULT_MEDIUM_WIDTH = "460px";
const FLIGHT_RESULT_SMALL_WIDTH = "420px";
const HEADER_HEIGHT = "80px";

export const Wrapper = styled.div<{ isOpen: boolean; isAuth: boolean }>`
  height: calc(100svh - ${({ isAuth }) => (isAuth ? HEADER_HEIGHT : "0px")});
  width: ${(props) =>
    props.isOpen ? `calc(100% - ${FLIGHT_RESULT_LARGE_WIDTH})` : "100%"};
  transition: width 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const MotionWrapper = motion(Wrapper);

export const SSelect = styled(Select)`
  width: 100%;
  border-radius: 8px;
  color: white;
  box-sizing: border-box;
  height: 44.89px !important;

  .ant-select-selector {
    background-color: #333 !important;
    border: 1px solid #404040 !important;
    color: white !important;
    display: flex;
    align-items: center;
    box-sizing: border-box !important;
    padding: 0 1rem;
  }

  .ant-select-selection-item {
    color: white !important;
    font-size: 1rem;
  }

  .ant-select-arrow {
    color: rgb(255 255 255 / 25%) !important;
  }
`;

export const RightSidebar = styled.div<{ isOpen: boolean; isAuth: boolean }>`
  position: fixed;
  bottom: 0;
  right: ${(props) => (props.isOpen ? "0" : "-520px")};
  width: 520px;
  height: calc(100svh - 80px);
  transition: right 0.3s ease-in-out;
  box-sizing: border-box;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  overflow-y: auto;
  background-color: #1a1a1a;
  z-index: 1000;

  h3,
  p {
    color: #fff;
  }

  @media (max-width: 768px) {
    width: 100vw;
    right: ${(props) => (props.isOpen ? "0" : "-100vw")};
  }
`;

export const HeaderRightbar = styled.div`
  display: flex;
  flex-direction: row;
  height: 80px;
  padding: 0 20px;
  align-items: center;
  /* border-bottom: 1px solid rgba(255, 255, 255, 0.1); */
  box-sizing: border-box;

  @media (max-width: 768px) {
    height: 60px;
    padding: 0rem 1rem;
  }
`;

export const WrapperForm = styled.div<{ isAuth: boolean }>`
  height: calc(100% - ${({ isAuth }) => (isAuth ? "100px" : "0px")});
  overflow-y: auto;

  /* Hide default scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #1a1924;
    border: 1px solid #242424;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #333333;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #363636;
  }

  @media (max-width: 768px) {
    height: calc(100svh - 160px);
  }
`;

export const PriceTag = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #fff;
  font-size: 0.875rem;

  .amount {
    font-weight: bold;
  }

  .period {
    color: #666;
  }
`;

// HOTEL INFORMATION POPUP
export const StyledInfoWindow = styled.div`
  width: 360px;
  display: flex;
  gap: 10px;

  @media (max-width: 520px) {
    flex-direction: column;
    width: fit-content;
  }
`;

export const Header = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
`;

export const HotelImage = styled.img`
  width: 120px;
  height: 80px;
  border-radius: 5px;
  object-fit: cover;

  @media (max-width: 520px) {
    width: 100%;
    height: 100px;
  }
`;

export const InfoColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 520px) {
    gap: 0.5rem;
  }
`;

export const DetailSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;

  & > *:first-child {
    align-items: center;
  }

  @media (max-width: 520px) {
    gap: 0.4rem;
  }
`;

export const InfoText = styled.p`
  margin: 0;
  display: flex;
  gap: 4px;

  p {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 0;
    margin: 0;
    min-height: 24px;
    b {
      margin-left: 5px;
    }
  }
`;

export const BookNow = styled.p`
  margin: 0;
  margin-left: 3px;
  cursor: pointer;
  color: #3a6df3;
  font-weight: 500;
  align-self: flex-end;
`;
